// import * as yup from "yup";
// import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   Button,
//   Form,
//   FormGroup,
//   Input,
//   Label,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
// } from "reactstrap";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useForm } from "react-hook-form";
// import Auth from "../services/authService";
// import {
//   CreateAccount,
//   DoNotHaveAccount,
//   FullName,
//   ForgotPassword,
//   Href,
//   Password,
//   RememberPassword,
//   SignIn,
//   SignInAccount,
//   SignInWith,
// } from "../constants";
// import { useAppDispatch, useAppSelector } from "../reduxToolkit/hooks";
// import {
//   loginSuccess,
//   otpData,
//   setLoginTime,
//   setMobileNumber,
//   setSignupOrLogin,
// } from "../reduxToolkit/reducers/layout/authSlice";

// import { setRole } from "../reduxToolkit/reducers/roles/roleSlice";
// import SocialLink from "./SocialLink";
// import { routes } from "../routers/routes";
// import { getRoleFromToken } from "../utils/jwtDecode";
// import ApiService from "../services/apiService";
// import { setUserId } from "../reduxToolkit/reducers/users/userSlice";
// import { setCookies, getCookies } from "../utils/cokkiesUtil";
// import { method } from "lodash";
// import { format } from "date-fns";
// import { PhoneInput } from "react-international-phone";
// import "react-international-phone/style.css";

// // Yup is a schema builder for runtime value parsing and validation

// //Login form
// const SignInForm = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   const [isPasswordVisible, setPasswordVisible] = useState(false);
//   const toggle = () => setPasswordVisible(!isPasswordVisible);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [input, setInput] = useState();
//   const [phone, setPhone] = useState<string>("");
//   const [isSignup, setIsSignup] = useState(false);

//   // useForm is a custom hook for managing forms with ease, with yupResolver to validate the form schema
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();

//   const handleChange = (e: any) => {
//     setInput(e.target.value);
//   };

//   const onSubmit = async (data: any) => {
//     if (!phone) {
//       toast.warn("Phone number required");
//     }

//     if (isSignup && !FullName) {
//       toast.warn("FullName is required");
//     }

//     if (isSignup) {
//       try {
//         const response = await ApiService.axiosApi(`/auth/signup-otp-request`, {
//           method: "POST",
//           data: {
//             FullName: FullName,
//             MobileNumber: phone.startsWith("+91")
//             ? phone.slice(3)
//             : phone,
//             Role: "support online",
//           },
//         });

//         if (response.success) {
//           if (response.data.type == "True") {

//             dispatch(setMobileNumber(phone));
//             dispatch(loginSuccess());
//             navigate(routes.OtpVerify);
//           } else {
//             toast.error(response.data.type);
//           }
//         } else {
//           toast.error(response.data.type);
//         }
//       } catch (e) {
//         console.log(e);
//       }
//     } else if (!isSignup) {
//       try {
//         const response = await ApiService.axiosApi(`/auth/GetOTPByMobileNo`, {
//           method: "GET",
//           params: {
//             MobileNumber: phone.startsWith("+91")
//             ? phone.slice(3)
//             : phone,
//           },
//         });

//         if (response.success) {
//           if (response.data.type == "True") {
//             console.log('ok')
//             dispatch(setMobileNumber(phone));
//             dispatch(loginSuccess());
//             navigate(routes.OtpVerify);
//           } else {
//             toast.error(response.data.type);
//           }
//         } else {
//           toast.error(response.data.type);
//         }
//       } catch (e) {
//         console.log(e);
//       }
//     }
//   };

//   const getUserId = async (data: any) => {
//     const email = {
//       EmailAddress: data,
//     };
//     try {
//       const response = await ApiService.axiosApi("/auth/getuserbyemail", {
//         method: "POST",
//         data: email,
//       });
//       if (response.success) {
//         dispatch(setUserId(response.data.id));
//       } else {
//         console.log("unable to get userid");
//       }
//     } catch (error: any) {
//       console.log(error);
//     }
//   };

//   return (
//     <>
//       <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
//         <div className="d-flex flex-column justify-content-center align-items-center mb-4">

//           <h3>Support Assistance</h3>
//         </div>
//         <h3>{SignInAccount}</h3>
//         <p>{"Enter your phone number to login"}</p>
//         {isSignup && (
//           <FormGroup>
//             <Label className="col-form-label">{FullName}</Label>
//             <input
//               className="form-control"
//               type="text"
//               {...register("fullName", {
//                 required: "Name is required",
//               })}
//             />
//             {errors.email && (
//               <p className="text-danger mt-1">
//                 {errors.email.message?.toString()}
//               </p>
//             )}
//           </FormGroup>
//         )}
//         <FormGroup>
//           <Label className="col-form-label">Phone Number</Label>
//           <PhoneInput
//             disableCountryGuess
//             defaultCountry="in"
//             hideDropdown
//             value={phone}
//             onChange={(value) => setPhone(value)}
//             inputStyle={{ width: "100%" }}
//           />
//           {!phone && (
//             <p className="text-danger mt-1">Phone number is required</p>
//           )}
//         </FormGroup>
//         <div className="form-group mb-0">
//           <span
//             style={{ cursor: "pointer", color: "blue" }}
//             onClick={() => {
//               setIsSignup(!isSignup);
//             }}
//           >
//             {isSignup
//               ? "Already have account? Login"
//               : "Don't have account? Sign Up"}
//           </span>
//         </div>

//         <div className="text-end mt-3">
//           <Button
//             color="primary"
//             size="md"
//             block
//             type="submit"
//             onClick={() =>
//               dispatch(setSignupOrLogin(isSignup ? "signup" : "login"))
//             }
//           >
//             {isSignup ? "Sign Up" : "Log In"}
//           </Button>
//         </div>
//       </Form>
//     </>
//   );
// };

// export default SignInForm;
import React, { useState, useEffect, useRef, useCallback } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useDispatch } from "react-redux";
import {
  login,
  setDuid as setDuidRedux,
  setSid,
  setPhoneNumber,
} from "../reduxToolkit/reducers/layout/authSlice";
import ApiService from "../services/apiService";

import { useNavigate } from "react-router-dom";
import DeviceInfo from "./DeviceInfo";
// import EmailSender from "./EmailSender";
import { toast } from "react-toastify";
import EmailSender from "./EmailSender";

const SignInForm: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [token, setToken] = useState("");
  const [duid, setDuid] = useState("");
  const [loading, setLoading] = useState(true);
  const [expired, setExpired] = useState(false);

  const [userSid, setUserSid] = useState<number | null>(null);
  const [userPhoneNumber, setUserPhoneNumber] = useState<string | null>(null);
  const [deviceMessage, setDeviceMessage] = useState<string>("");
const [emailSent, setEmailSent] = useState(false);

useEffect(() => {
  if (userSid && userPhoneNumber && deviceMessage && emailSent) {
    navigate("/dashboard", { replace: true });
  }
}, [userSid, userPhoneNumber, deviceMessage, emailSent, navigate]);

  // Track email sent status
  const emailSentRef = useRef(false);

  const pollingRef = useRef<number | null>(null);
  const expiryTimerRef = useRef<NodeJS.Timeout | null>(null);
  const isGeneratingRef = useRef(false);

  // Decode JWT Token
  const decodeToken = (token: string) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("Token decode error:", error);
      return null;
    }
  };

  // Extract DUID from token
  const extractDuid = (token: string) => {
    const prefix = "TIS|WebAccess|";
    if (!token.startsWith(prefix)) return "";
    return token.substring(prefix.length, prefix.length + 12);
  };

  // Poll API for login
  const poll = useCallback(
    async (extractedDuid: string) => {
      try {
        const res = await ApiService.axiosApi("/QRAuth/Login-By-Web", {
          method: "POST",
          data: { duid: extractedDuid },
        });

        if (res.success) {
          if (pollingRef.current) clearInterval(pollingRef.current);

          const authToken = res.data.token;
          const decodedToken = decodeToken(authToken);

          if (decodedToken) {
            const sid = parseInt(decodedToken.sid);
            const phoneNumber = decodedToken.phone_number;

            setUserSid(sid);
            setUserPhoneNumber(phoneNumber);

            dispatch(login({ token: authToken }));
            dispatch(setSid(sid));
            dispatch(setPhoneNumber(phoneNumber));

            toast.success("Login successful!");
          }

          return true;
        }

        return false;
      } catch (err: any) {
        console.error("Poll error:", err);
        return false;
      }
    },
    [dispatch]
  );

  // Generate QR code
  const generateToken = useCallback(async () => {
    if (isGeneratingRef.current) return;

    isGeneratingRef.current = true;
    setLoading(true);
    setExpired(false);

    setUserSid(null);
    setUserPhoneNumber(null);
    setDeviceMessage("");
    emailSentRef.current = false;

    if (expiryTimerRef.current) clearTimeout(expiryTimerRef.current);
    if (pollingRef.current) clearInterval(pollingRef.current);

    try {
     // const res = await ApiService.axiosApi("/qrauth/generate-qr", { method: "POST" });
     const res = await ApiService.axiosApi("/QRAuth/Generate-Qr", { method: "GET" });

      if (res.success) {
        const qrToken = res.data.token;
        setToken(qrToken);

        const extractedDuid = extractDuid(qrToken);
        setDuid(extractedDuid);
        sessionStorage.setItem("duid", extractedDuid);
        dispatch(setDuidRedux(extractedDuid));
         console.log("QR API response:", res);
          console.log(extractedDuid)
        // Start polling
        pollingRef.current = window.setInterval(() => poll(extractedDuid), 5000);

        toast.success("QR Code generated! Scan with your phone.");
      } else {
        toast.error("Failed to generate QR code");
      }
    } catch (err: any) {
      console.error("QR generation error:", err);
      toast.error("Error generating QR code");
    } finally {
      setLoading(false);
      isGeneratingRef.current = false;
    }

    expiryTimerRef.current = setTimeout(() => {
      setExpired(true);
      if (pollingRef.current) clearInterval(pollingRef.current);
      toast.warning("QR Code expired. Please generate a new one.");
    }, 2 * 60 * 1000);
  }, [dispatch, poll]);

  useEffect(() => {
    generateToken();

    return () => {
      if (expiryTimerRef.current) clearTimeout(expiryTimerRef.current);
      if (pollingRef.current) clearInterval(pollingRef.current);
    };
  }, [generateToken]);

  // Handle DeviceInfo messages
  const handleDeviceMessageChange = (message: string) => {
    setDeviceMessage(message);
  };


 useEffect(() => {
    if (emailSent) {
      navigate("/userlookup", { replace: true });
    }
  }, [emailSent, navigate]);

  return (
    <div className="main-page">
      <DeviceInfo onMessageChange={handleDeviceMessageChange} />
{/* Only mount EmailSender after sid, phone, and deviceMessage exist */}
      {userSid && userPhoneNumber && deviceMessage && !emailSent && (
        <EmailSender
          sid={userSid}
          phoneNumber={userPhoneNumber}
          deviceMessage={deviceMessage}
          onEmailSent={() => setEmailSent(true)}
        />
      )}




        <div className="qr-card">
          <div className="text">
            <h1>Steps to log in</h1>
            <ol>
              <li>Open Iroot on your phone</li>
              <li>Scan the QR code</li>
            </ol>
          </div>

          <div className="qr-code">
            {loading && <div>Generating QR...</div>}
            {!loading && !token && <div>Failed to generate QR</div>}
            {!loading && token && (
              <>
                <QRCodeSVG value={token} width={180} height={280} />
                {expired && (
                  <div className="qr-black-screen">
                    <img

                      alt="reload"
                      width={50}
                      height={50}
                      onClick={generateToken}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>

    </div>
  );
};

export default SignInForm;
